import script from "./TerminStepFuehrerschein.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminStepFuehrerschein.vue?vue&type=script&setup=true&lang=js"

import "./TerminStepFuehrerschein.vue?vue&type=style&index=0&id=390e46b1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390e46b1"]])

export default __exports__